import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pinClass',
    pure: false
})
export class PipePinClass implements PipeTransform {
    transform(pin: any): any {
        var cls='pin-point';

        if(pin?.properties?.categoryId)
          cls+=' category'+pin?.properties?.categoryId;

        if(pin?.properties?.perfilId)
          cls+=' perfil'+pin?.properties?.perfilId;

        if(pin?.properties?.actived == true)
          cls+=' actived';
          
        if(pin?.properties?.visited == true)
          cls+=' visited';

        if(pin?.properties?.focused == true)
          cls+=' focused';

        if(pin?.properties?.avatar)
          cls+=' withAvatar';

        if(pin?.properties?.new == true)
          cls+=' new';

        return cls;
    }
}